import React from 'react';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	}
}));

const TrackerTable = (props) => {
	const { data, ...rest } = props;
	const classes = useStyles();

	const _getTableColumns = () => (
		[
			{
				name: 'localId',
				label: 'Local Id',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'equipName',
				label: 'Equip Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'supplier',
				label: 'Supplier',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'commDate',
				label: 'Comm Date',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'mkOwner',
				label: 'Mk Owner',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'impOwner',
				label: 'Imp Owner',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'project',
				label: 'Project',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'comments',
				label: 'Comments',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'bssTech',
				label: 'Bss Tech',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'localType',
				label: 'Local Type',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'scheduleStatus',
				label: 'Schedule Status',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'dateEntry',
				label: 'Date Entry',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'week',
				label: 'Week',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'dayCount',
				label: 'Day Count',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'currentStatus',
				label: 'Current Status',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'deliveredDate',
				label: 'Delivered Date',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<div {...rest} className={clsx(classes.root)}>
			<DataTable
				id="trackerTable"
				title=""
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
			/>
		</div>
	);
};

TrackerTable.propTypes = {
	data: PropTypes.array.isRequired
};

export default TrackerTable;
